import React, { useState, useEffect } from "react";
import { Menu, X, ShoppingBag, Compass, Play } from "lucide-react";
import Logo from "./Logo";
import { nav } from "../mock";
import { useCart } from "../context/CartContext";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { count, openCart } = useCart();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      id="top"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white shadow-md" : "bg-white/90 backdrop-blur"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex items-center justify-between h-[72px] md:h-[96px]">
          <Logo imgClassName="h-[51px] md:h-[67px]" />

          <nav className="hidden lg:flex items-center gap-8">
            {nav.links.map((l) =>
              l.href === "#watch" ? (
                <a
                  key={l.label}
                  href={l.href}
                  className="inline-flex items-center gap-2 font-display text-[15px] text-white px-5 py-2.5 rounded-full transition-transform duration-200 hover:scale-105 shadow-sm"
                  style={{ backgroundColor: "#FF1228" }}
                >
                  <Play className="w-4 h-4" fill="white" strokeWidth={0} />
                  {l.label}
                </a>
              ) : (
                <a
                  key={l.label}
                  href={l.href}
                  className="font-display text-[17px] text-[#187EE4] hover:text-[#FF6C10] transition-colors duration-200"
                >
                  {l.label}
                </a>
              )
            )}
          </nav>

          <div className="flex flex-col items-center -mr-5 md:-mr-8">
            <div className="flex items-center gap-2 sm:gap-2.5">
            <a
              href={nav.shop.href}
              aria-label={nav.shop.label}
              title={nav.shop.label}
              className="inline-flex items-center transition-transform duration-200 hover:scale-105"
            >
              <img
                src={nav.shop.logo}
                alt={nav.shop.label}
                className="h-[38px] md:h-[50px] w-auto object-contain"
              />
            </a>
            <button
              onClick={openCart}
              className="relative inline-flex items-center gap-2 font-display text-[15px] text-white px-4 sm:px-5 py-2.5 rounded-full transition-transform duration-200 hover:scale-105 shadow-sm"
              style={{ background: "linear-gradient(135deg, #7a3d1f 0%, #a8532a 100%)" }}
              aria-label="Open Courage Cart"
            >
              <Compass className="w-4 h-4" style={{ color: "#F1C91F" }} />
              <span className="hidden sm:inline">Courage Cart</span>
              <ShoppingBag className="w-4 h-4 sm:hidden" />
              {count > 0 && (
                <span
                  className="absolute -top-1.5 -right-1.5 flex items-center justify-center min-w-[20px] h-5 px-1 rounded-full text-[11px] font-bold text-white shadow"
                  style={{ backgroundColor: "#FF1228" }}
                >
                  {count}
                </span>
              )}
            </button>
            <button
              className="lg:hidden text-[#187EE4] p-1"
              onClick={() => setOpen((o) => !o)}
              aria-label="Toggle menu"
            >
              {open ? <X className="w-7 h-7" /> : <Menu className="w-7 h-7" />}
            </button>
            </div>
            <span className="mt-0.5 w-full text-center block font-display tracking-wide text-[10px] md:text-[12px]" style={{ color: "#7a3d1f" }} data-testid="shop-coming-soon">Coming soon</span>
          </div>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-gray-100 px-5 py-4 space-y-3 shadow-lg">
          {nav.links.map((l) =>
            l.href === "#watch" ? (
              <a
                key={l.label}
                href={l.href}
                onClick={() => setOpen(false)}
                className="inline-flex items-center gap-2 font-display text-lg text-white px-5 py-2.5 rounded-full"
                style={{ backgroundColor: "#FF1228" }}
              >
                <Play className="w-4 h-4" fill="white" strokeWidth={0} />
                {l.label}
              </a>
            ) : (
              <a
                key={l.label}
                href={l.href}
                onClick={() => setOpen(false)}
                className="block font-display text-lg text-[#187EE4]"
              >
                {l.label}
              </a>
            )
          )}
          <a
            href={nav.shop.href}
            onClick={() => setOpen(false)}
            className="flex items-center gap-2 pt-2"
          >
            <img src={nav.shop.logo} alt={nav.shop.label} className="h-16 w-auto object-contain" />
          </a>
        </div>
      )}
    </header>
  );
};

export default Header;
